import { Box, Link, Typography } from '@mui/material';

export default function LegalLinks() {
  return (
    <Box sx={{ width: '100%', color: 'text.secondary', mt: 2, textAlign: 'center' }}>
      <Typography variant='caption' sx={{ color: 'inherit', lineHeight: 1.2 }}>
        <Link
          href='https://fun-zone.de/allgemeine-geschaeftsbedingungen/'
          target='_blank'
          rel='noopener noreferrer'
          underline='hover'
          color='inherit'
        >
          AGB
        </Link>
        {'\u00A0•\u00A0'}
        <Link
          href='https://fun-zone.de/datenschutz/'
          target='_blank'
          rel='noopener noreferrer'
          underline='hover'
          color='inherit'
        >
          Datenschutz
        </Link>
        {'\u00A0•\u00A0'}
        <Link
          href='https://fun-zone.de/impressum/'
          target='_blank'
          rel='noopener noreferrer'
          underline='hover'
          color='inherit'
        >
          Impressum
        </Link>
        {'\u00A0•\u00A0'}
        <Link
          href='https://funzoneverwa.recruitee.com/'
          target='_blank'
          rel='noopener noreferrer'
          underline='hover'
          color='inherit'
        >
          Karriere
        </Link>
      </Typography>
    </Box>
  );
}
